import { defineComponent as _defineComponent } from 'vue'
import { OnboardingStatus } from '@/enums/onboarding-status';

import { useUserStore } from '@/stores/pinia/useUserStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { getPlaySlugFromQuery } from '@/features/jwtv-titles-rental/helpers/shift72-player-helper';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useQuery } from '@/helpers/composables/useApollo';
import {
	ResolveShift72SlugDocument,
	type ResolveShift72SlugQuery,
	type ResolveShift72SlugQueryVariables,
} from '@/features/jwtv-titles-rental/graphql/queries/ResolveShift72Slug.query';
import { captureMessageForSentry } from '@/helpers/sentry-helper';
import { useMounted } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const GlobalHome = () => import('@/pages/home/GlobalHome.vue');
const OnboardedHome = () => import('@/pages/home/OnboardedHome.vue');

const UnsupportedCountry = () => import('@/pages/home/UnsupportedCountry.vue');

const { onboardingStatus, isUserOnboarded } = storeToRefs(useUserStore());
const { language, country } = storeToRefs(useLanguageStore());

// Shift72 TVOD: handle ?play=film/1234 on homepage
// When users arrive from email links (e.g. rental receipt), Shift72 redirects
// to justwatch.com?play=film/1234. We need to resolve the slug to a detail page
// and redirect there with the ?play= param preserved.
const route = useRoute();
const router = useRouter();
const isMounted = useMounted();

const playSlug = computed(() => getPlaySlugFromQuery((route.query as Record<string, string>) ?? {}));

const { onResult, onError } = useQuery<ResolveShift72SlugQuery, ResolveShift72SlugQueryVariables>(
	ResolveShift72SlugDocument,
	() => ({
		input: {
			slug: playSlug.value!,
			country: country.value,
			language: language.value,
		},
	}),
	{ enabled: computed(() => isMounted.value && !!playSlug.value) }
);

onResult(result => {
	const fullPath = result.data?.resolveShift72Slug?.fullPath;
	if (fullPath) {
		router.replace({ path: fullPath, query: { play: playSlug.value! } });
	}
});

onError(err => {
	captureMessageForSentry(
		'[Shift72 TVOD] Failed to resolve play slug on homepage',
		{ slug: playSlug.value, error: String(err) },
		'error'
	);
});

return { __sfc: true,GlobalHome, OnboardedHome, UnsupportedCountry, onboardingStatus, isUserOnboarded, language, country, route, router, isMounted, playSlug, onResult, onError, OnboardingStatus }
}

})